import React from 'react';
import Footer from './Footer';
import Header from './Header';
import './Layout.css';

export default function Layout({ children }) {
  return (
    <div className="layout-root">
      <Header />
      <div className="main">{children}</div>
      <Footer />
    </div>
  );
}
